import { render, staticRenderFns } from "./trainProgress.vue?vue&type=template&id=6db20ca6&scoped=true&"
import script from "./trainProgress.vue?vue&type=script&lang=js&"
export * from "./trainProgress.vue?vue&type=script&lang=js&"
import style0 from "./trainProgress.vue?vue&type=style&index=0&id=6db20ca6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db20ca6",
  null
  
)

export default component.exports